import { render, staticRenderFns } from "./PlacementList.vue?vue&type=template&id=576bb9f4&scoped=true"
import script from "./PlacementList.vue?vue&type=script&lang=js"
export * from "./PlacementList.vue?vue&type=script&lang=js"
import style0 from "./PlacementList.vue?vue&type=style&index=0&id=576bb9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576bb9f4",
  null
  
)

export default component.exports